import {ThemeType} from 'types/Theme'

import {link, text} from './typography'

export const typography: ThemeType['typography'] = {
  text,
  link
}
